var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "collapse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "collapse",
    transform: "translate(16.500000, 16.500000) rotate(-180.000000) translate(-16.500000, -16.500000) ",
    fill: "#3b3b3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,0.3125 C25.4401,0.3125 32.6875,7.55989 32.6875,16.5 C32.6875,25.4401 25.4401,32.6875 16.5,32.6875 C7.55988,32.6875 0.3125,25.4401 0.3125,16.5 C0.3125,7.55989 7.55988,0.3125 16.5,0.3125 Z M17.3175,11.5363 C17.7691,11.0848 17.7691,10.3527 17.3175,9.9012 C16.866,9.4496 16.134,9.4496 15.6825,9.9012 L9.9012,15.6825 C9.4496,16.134 9.4497,16.866 9.9012,17.3175 L15.6825,23.0988 C16.134,23.5504 16.866,23.5504 17.3175,23.0988 C17.7691,22.6472 17.7691,21.9153 17.3175,21.4637 L13.5102,17.6563 L22.2813,17.6563 C22.9198,17.6563 23.4375,17.1386 23.4375,16.5 C23.4375,15.8614 22.9198,15.3438 22.2813,15.3438 L13.5102,15.3438 L17.3175,11.5363 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncollapse);
export default __webpack_public_path__ + "static/media/uncollapse.8cd49843add5c30214fbe177ab1db75c.svg";
export { ForwardRef as ReactComponent };